import { Metadata, resolveDateRange } from '@dx-ui/dx-common';
import useSetupUsage, {
  SetupUsage,
} from '@dx-ui/dx-common/src/utils/useSetupUsage';
import {
  createCarrefourInvoiceTypeDetailsFilters,
  createColumnsCarrefourInvoiceTypeDetails,
  createColumnsContract,
  createColumnsDeliveryLocation,
  createColumnsDespatchAdvice,
  createColumnsOrder,
  createColumnsProcessDetails,
  createColumnsReceiptAdvice,
  createColumnsRegulatorDetails,
  createColumnsTotals,
  createCommonColumns,
  createCommonFilters,
  createContractFilters,
  createDeliveryLocationFilters,
  createDespatchAdviceFilters,
  createOrderFilters,
  createProcessDetailsFilters,
  createReceiptAdviceFilters,
  createRegulatorFilters,
  createSpecificColumnsInvoice,
  createSpecificInvoiceFilters,
  createTotalsFilters,
} from '../../aspects';
import { CommonList, DisplayContextualButtons } from '../../shared';

/**
 * Declare the additional columns to display vs commons
 */
const columns: any[] = [
  ...createCommonColumns(),
  ...createColumnsContract(),
  ...createColumnsDeliveryLocation(),
  ...createColumnsTotals(),
  ...createColumnsOrder(),
  ...createColumnsProcessDetails(),
  ...createColumnsDespatchAdvice(),
  ...createColumnsReceiptAdvice(),
  ...createColumnsCarrefourInvoiceTypeDetails(),
  ...createSpecificColumnsInvoice(),
  ...createColumnsRegulatorDetails(),
];

/**
 * Specific filters
 */
const additionalFilters: any[] = [
  ...createCommonFilters(),
  ...createContractFilters(),
  ...createDeliveryLocationFilters(),
  ...createTotalsFilters(),
  ...createOrderFilters(),
  ...createProcessDetailsFilters(),
  ...createDespatchAdviceFilters(),
  ...createReceiptAdviceFilters(),
  ...createCarrefourInvoiceTypeDetailsFilters(),
  ...createSpecificInvoiceFilters(),
  ...createRegulatorFilters(),
];

const InvoiceList = (props) => {
  const setupUsage: SetupUsage | undefined = useSetupUsage();
  const isDemoSetup: boolean = setupUsage === SetupUsage.DEMO;
  return (
    <CommonList
      title='dxMessages.invoices.title'
      {...props}
      columns={columns}
      additionalFilters={additionalFilters}
      contextualToolbar={<DisplayContextualButtons />}
      filterDefaultValues={
        isDemoSetup
          ? {}
          : {
              [Metadata.created]: resolveDateRange({
                predefinedRange: 'last-7-days',
              }),
            }
      }
    />
  );
};

export default InvoiceList;
